// extracted by mini-css-extract-plugin
export default {"back":"link_back__RfKnR"};